import { gql } from '@apollo/client'
import { Caption, Col, Heading, Row } from '@farol-ds/react'
import { Price } from '@jusbrasil-web/shared-price'

import { CheckoutButton } from '../checkout-button'
import { BenefitsList } from '../dynamic-multiple-offers-switch-frequency-new-benefits-lock/components/benefits-list'
import { OneClickButton } from '../one-click-button'
import {
  CustomPlanLockContent_OfferLockDataFragment,
  CustomPlanLockContent_ViewerFragment,
} from './__generated__/custom-plan-lock-content.graphql'
import styles from './custom-plan-lock.module.scss'

export interface CustomPlanLockContentProps {
  offerLockData: CustomPlanLockContent_OfferLockDataFragment
  viewer: CustomPlanLockContent_ViewerFragment
}

export function CustomPlanLockContent({ offerLockData, viewer }: CustomPlanLockContentProps) {
  const { header, body, footer } = offerLockData || {}
  const { title } = header || {}
  const [card] = body?.cards || []

  return (
    <Row>
      <Col xs={12}>
        <Heading size="lg" className={styles.customPlanLockHeading} asChild>
          <h3>{title}</h3>
        </Heading>

        <div className={styles.customPlanLockPricing}>
          <Price align="center" size="lg">
            {card?.offer?.priceTitle && (
              <Price.Title>
                <span dangerouslySetInnerHTML={{ __html: card.offer.priceTitle }}></span>
              </Price.Title>
            )}
            <Price.Value>
              {card?.offer?.priceText}
              {card?.offer?.frequency && (
                <Price.ValueFrequency>{card?.offer?.frequency}</Price.ValueFrequency>
              )}
            </Price.Value>
          </Price>
        </div>

        <CheckoutButton offerLockCard={card} kind="primary" />
        <div className={styles.customPlanLockOneClickButton}>
          <OneClickButton offerLockCard={card} viewer={viewer} kind="primary" />
        </div>

        <BenefitsList offerLockCard={card} listContainerClassName={styles.customPlanLockBenefits} />

        {footer.text && (
          <div className={styles.customPlanLockFooterContainer}>
            <Caption>{footer.text}</Caption>
          </div>
        )}
      </Col>
    </Row>
  )
}

CustomPlanLockContent.fragments = {
  offerLockData: gql`
    fragment CustomPlanLockContent_offerLockData on OfferLockData {
      header {
        title
      }
      body {
        cards {
          offer {
            priceTitle
            priceText
            frequency
          }
          ...OneClickButton_offerLockCard
          ...CheckoutButton_offerLockCard
          ...NewBenefitsList_offerLockCard
        }
      }
      footer {
        text
      }
    }
    ${OneClickButton.fragments.offerLockCard}
    ${CheckoutButton.fragments.offerLockCard}
    ${BenefitsList.fragments.offerLockCard}
  `,
  viewer: gql`
    fragment CustomPlanLockContent_viewer on Profile {
      ...OneClickButton_viewer
    }
    ${OneClickButton.fragments.viewer}
  `,
}
